import store from '@/store';

export default [
  {
    path: '/relatorio-comissoes',
    name: 'relatorio-comissoes',
    component: () => import('@/views/relatorios/comissoes/Index.vue'),
    meta: {
      action: 'read',
      resource: 'RelatorioComissoes',
      tenantPref: 'comissoesAtivo',
    },
    beforeEnter: (to, from, next) => {
      const loaded = store.getters['preferencias/loaded'];
      const ativo = store.getters['preferencias/comissoesAtivo'];
      if (loaded && !ativo) {
        next({ name: 'home' });
      } else {
        next();
      }
    },
  },
];
